import React from 'react';
import { Grid, Typography} from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';



function GovernmentFeatured() {
  const globalClasses = globalUseStyles()
  return (
<ThemeProvider theme={theme}>
  <Container className={globalClasses.featuredContainer} maxWidth={false} component="section">
        <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={12} md={12}  >
                <Typography variant="subtitle1">Government Services</Typography>
                <Typography variant="h1">Public Service Does Good.</Typography>
                <Typography variant="body1">At Pantheon, we are honored to bring cutting edge technologies and user centered experiences to government agencies. We’ve helped government agencies accelerate their digital and analytics capabilities for over 20 years.  </Typography>
            </Grid>
        </Grid>
    </Container>
</ThemeProvider>
  );
};

export default GovernmentFeatured;